"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckoutStep = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutDelivery = require("@ori/checkout-delivery");
var _checkoutUi = require("@ori/checkout-ui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _topArea = require("@ori/top-area");
var _react = require("react");
var _contexts = require("../../contexts");
var _navigationContext = require("../../contexts/navigationContext");
var _models = require("../../models");
var _dispatchUserActionEvent = require("../../utils/dispatchUserActionEvent");
var _BillingAddress = require("../BillingAddress");
var _FormattedMessage = require("../FormattedMessage");
var _MyInformation = require("../MyInformation");
var _OrderPreview = require("../OrderPreview");
var _Payment = require("./Payment");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const GAP_BETWEEN_SECTIONS = 20;
const CheckoutStep = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const configuration = (0, _contexts.useCheckout)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    billingState,
    setBillingState,
    setCurrentStep
  } = (0, _navigationContext.useNavigationContext)();
  const {
    handleBillingAddressRefresh
  } = (0, _BillingAddress.useBillingAddress)();
  const billingAddressRootRef = (0, _react.useRef)(null);
  const onChangeButtonClick = (0, _react.useCallback)(() => {
    // analytics
    (0, _dispatchUserActionEvent.dispatchUserActionEvent)([_models.MetaHierarchy.SelectOrderPreview]);
    setCurrentStep(_models.ShoppingStep.Basket);
  }, [setCurrentStep]);
  const onContinueButtonClick = (0, _react.useCallback)(() => {
    setBillingState('loading');
    setTimeout(() => {
      setBillingState('enabled');
      setTimeout(() => {
        if (billingAddressRootRef.current) {
          const scrollOffset = (isMobile ? _topArea.MOBILE_WITH_TOP_AREA_BANNER_HEIGHT : _topArea.DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT) + GAP_BETWEEN_SECTIONS;
          window.scrollTo({
            behavior: 'smooth',
            top: billingAddressRootRef.current.offsetTop - scrollOffset
          });
        }
      });
    }, 800);
  }, [isMobile, setBillingState]);
  const onDeliveryAddressChange = (0, _react.useCallback)(() => {
    setBillingState('disabled');
  }, [setBillingState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SectionWrapper, {
      "data-testid": getTestId(_models.TestId.BasketSection),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SectionHeader, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "basket"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.MiniButton, {
          onClick: onChangeButtonClick,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "edit"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OrderPreview.OrderPreview, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyInformation.MyInformation, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutDelivery.CheckoutDeliveryController, {
      configuration: {
        ...configuration,
        showContinueButton: billingState === 'disabled',
        isSimplifiedCheckout: true,
        handleBillingAddressRefresh,
        billingState,
        onContinueButtonClick,
        onDeliveryAddressChange
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BillingAddress.BillingAddress, {
      billingAddressRootRef: billingAddressRootRef,
      addressFormat: configuration.addressFormat
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Payment.Payment, {})]
  });
};
exports.CheckoutStep = CheckoutStep;
var _default = exports.default = CheckoutStep;